<template>
  <div class="cc-consents__main">
    <div class="cc-consent" v-if="config.type === 'text'">
      {{ translations['By continuing you agree with terms of service and privacy policy.'] }}
      <a :href="config.terms_of_use.link" target="_blank" class="cc-link cc-link--inline">{{ translations['Terms of service'] }}</a>
      {{ translations['and'] }}
      <a :href="config.privacy_policy.link" target="_blank" class="cc-link cc-link--inline">{{ translations['privacy policy'] }}</a>.
    </div>
    <div class="cc-consent" v-if="config.type === 'checkbox'">
      <div class="cc-form-input">
        <input
            id="consents.termsOfService"
            type="checkbox"
            class="cc-input cc-input--checkbox"
            :checked="checked"
            @change="updateValue"
        >
        <label for="consents.termsOfService" class="cc-label cc-label--checkbox">
          {{ translations['I accept'] }}
          <a :href="config.terms_of_use.link" target="_blank" class="cc-link cc-link--inline">{{ translations['Terms of service'] }}</a>
          {{ translations['and'] }}
          <a :href="config.privacy_policy.link" target="_blank" class="cc-link cc-link--inline">{{ translations['privacy policy'] }}</a>.
        </label>
      </div>
      <div v-if="consents.errors.termsOfService">
        <span class="consents--error">{{ consents.errors.termsOfService }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import SelectedPayment from "@/components/Store919/SelectedPayment";

export default {
  components: {SelectedPayment},
  computed: {
    ...mapState({
      translations: state => state.translations,
      config: state => state.config.consents,
      consents: state => state.consents,
    }),
    checked() {
      return this.consents.termsOfService && this.consents.privacyPolicy;
    },
  },
  methods: {
    updateValue(e) {
      this.$store.commit('SET_CONSENT_TERMS_OF_SERVICE_ERROR', '');
      this.$store.commit('SET_CONSENT_TERMS_OF_SERVICE', e.target.checked);
      this.$store.commit('SET_CONSENT_PRIVACY_POLICY', e.target.checked);
    }
  },
  mounted: function () {
    if (this.config.type === 'checkbox') {
      this.$store.commit('SET_CONSENT_TERMS_OF_SERVICE', false);
      this.$store.commit('SET_CONSENT_PRIVACY_POLICY', false);
    } else {
      this.$store.commit('SET_CONSENT_TERMS_OF_SERVICE', true);
      this.$store.commit('SET_CONSENT_PRIVACY_POLICY', true);
    }
  },
};
</script>
<style scoped>
  .cc-label.cc-label--checkbox {
    margin-left: 8px;
  }
  .consents--error {
    color: red;
    font-size: 14px;
  }
  .cc-consents__main {
    font-size: 0.875rem;
  }
</style>